import { useState, useCallback, useMemo } from "react";
import { useSelector } from 'react-redux';
import { Box } from "@mui/material";
import { LAYOUT_HEIGHT } from 'state/constants';
import OtpByPorts from 'scenes/dashboard/OtpByPorts';
import ChartDialog from 'components/chartNivo/ChartDialog';


export function OtpByPortsCard({ data }) {
  const params = useSelector((state) => state.params);
  const HOME_BASES = params?.find((item) => item.param === "HOME_BASES")?.value || "SGN, HAN, DAD";

  const [chartOpen, setChartOpen] = useState(false);

  const [delayType, setDelayType] = useState(() => {
    return localStorage.getItem('otpByPorts_delayType') || "departure";
  });

  const [selectedPorts, setSelectedPorts] = useState(() => {
    try {
      const saved = localStorage.getItem('otpByPorts_selectedPorts');
      if (saved) return JSON.parse(saved);
    } catch {}
    return HOME_BASES.split(',').map(p => p.trim()).filter(Boolean);
  });

  const handleDelayTypeChange = useCallback((value) => {
    setDelayType(value);
    localStorage.setItem('otpByPorts_delayType', value);
  }, []);

  const handleSelectedPortsChange = useCallback((value) => {
    setSelectedPorts(value);
    localStorage.setItem('otpByPorts_selectedPorts', JSON.stringify(value));
  }, []);

  const handleOpen = useCallback(() => setChartOpen(true), []);
  const handleClose = useCallback(() => setChartOpen(false), []);

  const dialogStyles = useMemo(() => ({
    height: LAYOUT_HEIGHT,
    borderRadius: 1,
    border: "1px solid",
    borderColor: "neutral.deep",
    backgroundColor: "background.default",
  }), []);

  return (
    <>
      <Box
        id="otpByPorts"
        component="section"
        height={450}
        pr={0.5}
        onDoubleClick={handleOpen}
        sx={{
          borderRadius: 1,
          border: "1px solid",
          borderColor: "neutral.deep",
          backgroundColor: "background.default",
        }}
      >
        <OtpByPorts
          flights={data}
          delayType={delayType}
          onDelayTypeChange={handleDelayTypeChange}
          selectedPorts={selectedPorts}
          onSelectedPortsChange={handleSelectedPortsChange}
        />
      </Box>

      {chartOpen && (
        <ChartDialog
          open={chartOpen}
          onClose={handleClose}
          chartComponent={
            <Box sx={dialogStyles}>
              <OtpByPorts
                flights={data}
                delayType={delayType}
                onDelayTypeChange={handleDelayTypeChange}
                selectedPorts={selectedPorts}
                onSelectedPortsChange={handleSelectedPortsChange}
              />
            </Box>
          }
        />
      )}
    </>
  );
}
